import { render, staticRenderFns } from "./biddingPlan.vue?vue&type=template&id=2a04549c&scoped=true"
import script from "./biddingPlan.vue?vue&type=script&lang=js"
export * from "./biddingPlan.vue?vue&type=script&lang=js"
import style0 from "./biddingPlan.vue?vue&type=style&index=0&id=2a04549c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a04549c",
  null
  
)

export default component.exports